/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AccountStatus } from './accountStatus';
import { CounselRole } from './counselRole';
import { Reaction } from './reaction';
import { UserBasic } from './userBasic';
import { UserRole } from './userRole';

export interface UserExtended extends UserBasic { 
    user_roles: Array<UserRole>;
    reaction: Reaction;
    counsel_role?: CounselRole;
}